import { render, staticRenderFns } from "./PayRangeDrawerHeader.vue?vue&type=template&id=6a9d9ec7&scoped=true"
import script from "./PayRangeDrawerHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeDrawerHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeDrawerHeader.vue?vue&type=style&index=0&id=6a9d9ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d9ec7",
  null
  
)

export default component.exports